import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_FOODSTORM = `${URL_RETAILER_SCOPED}/foodstorm`
const URL_FOODSTORM_SITE_SCOPED = `${URL_FOODSTORM}${URL_SITE_SCOPED}`
const URL_FOODSTORM_CREATE_CART = `${URL_FOODSTORM_SITE_SCOPED}/carts/create`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'foodstorm'> | DashRouteType<'foodstorm-create-cart'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  foodstorm: URL_FOODSTORM_SITE_SCOPED,
  'foodstorm-create-cart': URL_FOODSTORM_CREATE_CART,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
